import React from 'react'

interface MainContentProps {
  children: React.ReactNode
}

export const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <div className="mx-auto mt-8 flex max-w-7xl flex-col gap-6 @container md:flex-row">
      {children}
    </div>
  )
}
